import { render, staticRenderFns } from "./InformativeMessage.vue?vue&type=template&id=46bb617c&scoped=true&"
import script from "./InformativeMessage.vue?vue&type=script&lang=js&"
export * from "./InformativeMessage.vue?vue&type=script&lang=js&"
import style0 from "./InformativeMessage.vue?vue&type=style&index=0&id=46bb617c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb617c",
  null
  
)

export default component.exports